import { useMemo } from "react";
import { useUserConfig } from "./useUserConfig";

/**
 * Returns workspace permissions for the user.
 *
 * canViewWorkspace: true if user is a workspace member (can see members list, read-only)
 * canManageWorkspace: true if user is admin (can create users, change roles, etc.)
 */
export function useUserWorkspace() {
  const { workspaces, isLoading, error } = useUserConfig();

  const defaultWorkspace = workspaces?.[0];

  const canManageWorkspace = useMemo(() => {
    // Check if user can manage workspace members (admin only)
    return defaultWorkspace?.permissions?.can_manage_members ?? false;
  }, [defaultWorkspace]);

  const canViewWorkspace = useMemo(() => {
    // Any workspace member can view (has can_view permission)
    return defaultWorkspace?.permissions?.can_view ?? false;
  }, [defaultWorkspace]);

  return {
    workspaces,
    canManageWorkspace, // Admin only - can create users, change roles, etc.
    canViewWorkspace, // Any member - can see members list (read-only)
    isLoading,
    error,
  };
}
